export const SEO_NO_MEDIUM_KEY = 'noMedium';
export const SEO_NO_LAYOUT_KEY = 'noLayout';
export const SEO_KEYWORDS = {
    [SEO_NO_MEDIUM_KEY]: {
        [SEO_NO_LAYOUT_KEY]: {
            kw1: 'Wall Art',
            kw2: '',
            kw3: 'art'
        },
        multiple: {
            kw1: 'Multi Panel Art',
            kw2: 'Prints',
            kw3: 'prints'
        },
        canvas: {
            kw1: 'Canvas Wall Art',
            kw2: 'Prints',
            kw3: 'canvas wall art'
        },
        'framed canvas': {
            kw1: 'Framed Canvas Prints',
            kw2: 'Art Prints',
            kw3: 'canvas prints'
        },
        'framed print': {
            kw1: 'Framed Prints',
            kw2: 'Pictures',
            kw3: 'art prints'
        },
        'poster print': {
            kw1: 'Posters',
            kw2: 'Prints',
            kw3: 'art'
        }
    },
    painting: {
        [SEO_NO_LAYOUT_KEY]: {
            kw1: 'Paintings',
            kw2: 'Wall Art',
            kw3: 'art'
        },
        multiple: {
            kw1: 'Multi Panel Paintings',
            kw2: 'Art Prints',
            kw3: 'painting prints'
        },
        canvas: {
            kw1: 'Canvas Paintings',
            kw2: 'Art Prints',
            kw3: 'canvas art'
        },
        'framed canvas': {
            kw1: 'Framed Canvas Paintings',
            kw2: 'Art Prints',
            kw3: 'canvas paintings'
        },
        'framed print': {
            kw1: 'Framed Paintings',
            kw2: 'Art Prints',
            kw3: 'wall art paintings'
        },
        'poster print': {
            kw1: 'Wall Posters',
            kw2: 'Art Prints',
            kw3: 'painting art'
        }
    },
    drawing: {
        [SEO_NO_LAYOUT_KEY]: {
            kw1: 'Drawings',
            kw2: 'Wall Art',
            kw3: 'art'
        },
        multiple: {
            kw1: 'Multi Panel Drawings',
            kw2: 'Artwork',
            kw3: 'drawings'
        },
        canvas: {
            kw1: 'Canvas Drawings',
            kw2: 'Artwork',
            kw3: 'artwork'
        },
        'framed canvas': {
            kw1: 'Framed Canvas Drawings',
            kw2: 'Artwork',
            kw3: 'wall art drawings'
        },
        'framed print': {
            kw1: 'Framed Print Drawings',
            kw2: 'Artwork',
            kw3: 'art sketches'
        },
        'poster print': {
            kw1: 'Poster Print',
            kw2: 'Artwork',
            kw3: 'art drawings'
        }
    },
    'digital-art': {
        [SEO_NO_LAYOUT_KEY]: {
            kw1: 'Digital Art',
            kw2: 'Wall Art',
            kw3: 'art'
        },
        multiple: {
            kw1: 'Multi Panel Digital Art',
            kw2: 'Pictures',
            kw3: 'prints'
        },
        canvas: {
            kw1: 'Canvas Digital Art',
            kw2: 'Pictures',
            kw3: 'canvas wall art'
        },
        'framed canvas': {
            kw1: 'Framed Canvas Digital Art',
            kw2: 'Pictures',
            kw3: 'canvas prints'
        },
        'framed print': {
            kw1: 'Framed Print Digital Art',
            kw2: 'Pictures',
            kw3: 'art prints'
        },
        'poster print': {
            kw1: 'Digital Art Posters',
            kw2: 'Pictures',
            kw3: 'art'
        }
    },
    photography: {
        [SEO_NO_LAYOUT_KEY]: {
            kw1: 'Photographs',
            kw2: 'Wall Art',
            kw3: 'art'
        },
        multiple: {
            kw1: 'Multi Panel Photographs',
            kw2: 'Wall Prints',
            kw3: 'photographs'
        },
        canvas: {
            kw1: 'Canvas Photographs',
            kw2: 'Wall Prints',
            kw3: 'art photography'
        },
        'framed canvas': {
            kw1: 'Framed Canvas Photographs',
            kw2: 'Wall Prints',
            kw3: 'photography prints'
        },
        'framed print': {
            kw1: 'Framed Photographs',
            kw2: 'Wall Prints',
            kw3: 'wall art photography'
        },
        'poster print': {
            kw1: 'Poster Art',
            kw2: 'Wall Prints',
            kw3: 'photo art'
        }
    },
    graffiti: {
        [SEO_NO_LAYOUT_KEY]: {
            kw1: 'Graffiti',
            kw2: 'Wall Art',
            kw3: 'art'
        },
        multiple: {
            kw1: 'Multi Panel Graffiti Art',
            kw2: 'Prints',
            kw3: 'prints'
        },
        canvas: {
            kw1: 'Canvas Graffiti Art',
            kw2: 'Prints',
            kw3: 'canvas wall art'
        },
        'framed canvas': {
            kw1: 'Framed Canvas Graffiti Art',
            kw2: 'Prints',
            kw3: 'canvas prints'
        },
        'framed print': {
            kw1: 'Framed Print Graffiti Art',
            kw2: 'Prints',
            kw3: 'art prints'
        },
        'poster print': {
            kw1: 'Art Posters',
            kw2: 'Prints',
            kw3: 'art'
        }
    },
    watercolor: {
        [SEO_NO_LAYOUT_KEY]: {
            kw1: 'Watercolor',
            kw2: 'Wall Art',
            kw3: 'art'
        },
        multiple: {
            kw1: 'Multi Panel Watercolor',
            kw2: 'Art',
            kw3: 'prints'
        },
        canvas: {
            kw1: 'Canvas Watercolor',
            kw2: 'Art',
            kw3: 'canvas wall art'
        },
        'framed canvas': {
            kw1: 'Framed Canvas Watercolor',
            kw2: 'Art',
            kw3: 'canvas prints'
        },
        'framed print': {
            kw1: 'Framed Print Watercolor',
            kw2: 'Art',
            kw3: 'art prints'
        },
        'poster print': {
            kw1: 'Watercolor Posters',
            kw2: 'Art',
            kw3: 'art'
        }
    }
};
